// extracted by mini-css-extract-plugin
export default {"SecaoCard":"SecaoCard_SecaoCard__xnd-b","LogoImg":"SecaoCard_LogoImg__k5hs1","LogoArea":"SecaoCard_LogoArea__IQqdE","LogoTexto":"SecaoCard_LogoTexto__h-clV"};